import qs from 'query-string';
import cookie from 'js-cookie';

const utm = {
  create: () => {
    const query = qs.parse(window.location.search);

    const utmResource = {
      utm_source: query.utm_source,
      utm_medium: query.utm_medium,
      utm_campaign: query.utm_campaign,
      utm_term: query.utm_term,
      utm_content: query.utm_content
    };

    if (!Object.keys(utmResource).length) {
      utm.clear();
      return;
    }

    const exp = new Date(new Date().getTime() + 24 * 60 * 60 * 14); // 14 days
    cookie.set('LIFEPAL_UTM', `${qs.stringify(utmResource)}`, {
      expires: exp,
      path: '/',
      domain: window.location.host
    });
  },
  getAll: () => {
    const lifepalUTM = cookie.get('LIFEPAL_UTM');

    if (!lifepalUTM) {
      utm.create();
      return qs.parse(cookie.get('LIFEPAL_UTM'));
    }

    return qs.parse(lifepalUTM);
  },
  clear: () => {
    cookie.remove('LIFEPAL_UTM');
  }
};

export default utm;
